<template>
  <div class="relative inline-block" style="overflow: visible">
    <div
      @mouseenter="show = true"
      @mouseleave="show = false"
      class="cursor-pointer"
    >
      <slot></slot>
    </div>
    <div
      v-show="show"
      class="absolute z-[9999] px-3 py-2 text-xs text-gray-700 bg-white border border-gray-200 rounded shadow-md"
      :style="{
        bottom: 'calc(100% + 8px)',
        left: '50%',
        transform: 'translateX(-50%)',
        width: width ? `${width}px` : '200px',
      }"
      v-html="text"
    ></div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'TooltipComponent',
  props: {
    text: {
      type: String,
      required: true,
    },
    width: {
      type: [String, Number],
      default: 200,
    },
  },
  setup() {
    const show = ref(false);
    return { show };
  },
};
</script>
